import RestRepository from "../../infra/RestRepository";

export default class LuccaInstallRestRepo extends RestRepository {
  constructor() {
    super("/api/lucca-install");
  }
}
